export default {
      id: "arrowRight-usage",
      viewBox: "0 0 53 28",
      url: "../../assets/" + "sprite.svg#arrowRight-usage",
      toString: function () {
        return this.url;
      }
    }